/**
 * @ngdoc directive
 * @name WebCoreModule.directive:wcOfflineIndicator
 * @restrict A
 * @description
 * The wcOfflineIndicator directive includes a response interceptor to watch for when requests over the network fail. When things
 * fail, this directive will add an AlertConsole like message to notify the user of the situation.
 */

angular.module('WebCoreModule')
	.directive('wcOfflineIndicator', function() {
		return {
			restrict: 'A',
			template: '<div><div id="offline-indicator" class="container-fluid" ng-switch="checking">' +
			'<uib-alert type="warning"><span class="glyphicon glyphicon-warning-sign" ng-switch-when="false"></span><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate" ng-switch-when="true"></span>' +
			'<span>{{\'offlineIndicator.offlineMessage\'|translate}} ' +
			'<a href ng-click="checkNetworkState()">{{\'offlineIndicator.retryConnection\'|translate}}</a></span></uib-alert></div>' +
			'<div id="unavailable-offline" class="container-fluid" ng-switch="checking">' +
			'<uib-alert type="danger"><span class="glyphicon glyphicon-remove-circle" ng-switch-when="false"></span><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate" ng-switch-when="true"></span>' +
			'<span>{{\'offlineIndicator.unavailableMessage\'|translate}} ' +
			'<a href ng-click="checkNetworkState()">{{\'offlineIndicator.retryConnection\'|translate}}</a></span></uib-alert></div>' +
			'<div id="unauth-indicator" class="container-fluid" ng-switch="checking">' +
			'<uib-alert type="warning"><span class="glyphicon glyphicon-warning-sign" ng-switch-when="false"></span><span class="glyphicon glyphicon-refresh glyphicon-refresh-animate" ng-switch-when="true"></span>' +
				'<span>{{\'unauthIndicator.unauthMessage\'|translate}} ' +
			'<a href ng-click="wslLogin()">{{\'unauthIndicator.wslLogin\'|translate}}</a></span></uib-alert></div></div>',
			replace: true,
			controller: ['WcHttpRequestService', '$scope', '$window', '$timeout', '$state', 'WcTranslateConfiguratorService', 'WcConstants',
				function(WcHttpRequestService, $scope, $window, $timeout, $state, WcTranslateConfiguratorService, WcConstants) {

				WcTranslateConfiguratorService.loadPartAndRefresh('WC-offlineIndicator');

				// Ensure directive is hidden initially
				$('#offline-indicator').hide();
				$('#unavailable-offline').hide();
				$('#unauth-indicator').hide();

				$scope.checking = false;

				this.showOfflineIndicator = function() {
					$('#offline-indicator').show();
					var alertBox = $('#offline-indicator .alert');
					alertBox.addClass('pulse');
					$timeout(function(){
						alertBox.removeClass('pulse');
					},2000);
					$window.scrollTo(0,1);
				};

				this.hideOfflineIndicator = function() {
					$('#offline-indicator').hide();
				};

				this.showUnavailableOffline = function() {
					$('#unavailable-offline').show();
					var alertBox = $('#unavailable-offline .alert');
					alertBox.addClass('pulse');
					$timeout(function(){
						alertBox.removeClass('pulse');
					},2000);
					$window.scrollTo(0,1);
				};

				this.hideUnavailableOffline = function() {
					$('#unavailable-offline').hide();
				};

				this.showUnauthIndicator = function() {
					$('#unauth-indicator').show();
					var alertBox = $('#unauth-indicator .alert');
					alertBox.addClass('pulse');
					$timeout(function(){
						alertBox.removeClass('pulse');
					},2000);
					$window.scrollTo(0,1);
				};

				this.hideUnauthIndicator = function() {
					$('#unauth-indicator').hide();
				};

				$scope.checkNetworkState = function() {
					$scope.checking = true;
					WcHttpRequestService.getNetworkState().then(function(state){
						//after clicking the check link, force a redirect to wsl if needed
						if(state === 'unauthenticated') {
							$scope.wslLogin();
						}
						$scope.checking = false;
					});
				};

				$scope.wslLogin = function() {
					$window.location.href = WcConstants.wslBaseUrl + encodeURIComponent($window.location.href);
				};

				WcHttpRequestService.addResponseInterceptor(angular.bind(this, function(){
					// hide indicators if we have a successful ReST response
					this.hideOfflineIndicator();
					this.hideUnavailableOffline();
					this.hideUnauthIndicator();
				}));

				$scope.$on('Offline', angular.bind(this, function() {
					if($state.current.data && $state.current.data.unavailableOffline) {
						this.hideOfflineIndicator();
						this.showUnavailableOffline();
						this.hideUnauthIndicator();
					}
					else {
						this.showOfflineIndicator();
						this.hideUnavailableOffline();
						this.hideUnauthIndicator();
					}
				}));

				$scope.$on('Unauthenticated', angular.bind(this, function() {
					this.showUnauthIndicator();
					this.hideOfflineIndicator();
					this.hideUnavailableOffline();
				}));

				return $scope.offlineIndicator = this;
			}]
		};
	});